function getHeaders(requestProps) {
    return {
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
        Authorization: `Bearer ${requestProps.token}`,
    };
}
function getBody(requestProps) {
    const body = requestProps.body;
    return body ? JSON.stringify(body) : '';
}
async function getResponseData(response) {
    const text = await response.text();
    try {
        return JSON.parse(text);
    }
    catch (_a) {
        return text;
    }
}
export async function get(url, requestProps) {
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'omit',
        headers: getHeaders(requestProps),
    });
    return getResponseData(response);
}
export async function put(url, requestProps) {
    const response = await fetch(url, {
        method: 'PUT',
        credentials: 'omit',
        headers: getHeaders(requestProps),
        body: getBody(requestProps),
    });
    return getResponseData(response);
}
export async function post(url, requestProps) {
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'omit',
        headers: getHeaders(requestProps),
        body: getBody(requestProps),
    });
    return getResponseData(response);
}
